import React from 'react';
import InputStatsCore from "../../components/InputStatsCore";
import type { InputStatsSharedProps } from "../../types/input-stats-props";

function InputStats({ 
  selectedPokemon, 
  setSelectedPokemon, 
  statInputs, 
  handleStatChange, 
  handlePersonalityChange, 
  createIncrementHandler, 
  createDecrementHandler, 
  totalEvs,
  handleIndividualValueChange 
}: InputStatsSharedProps) {
  return (
    <InputStatsCore
      selectedPokemon={selectedPokemon}
      setSelectedPokemon={setSelectedPokemon}
      statInputs={statInputs}
      handleStatChange={handleStatChange}
      handlePersonalityChange={handlePersonalityChange}
      createIncrementHandler={createIncrementHandler}
      createDecrementHandler={createDecrementHandler}
      totalEvs={totalEvs}
      handleIndividualValueChange={handleIndividualValueChange}
    />
  );
}

export default InputStats;
